import { Pipe, PipeTransform } from '@angular/core';
import { AppLocaleService } from '../services/app-locale.service';
import { localizedName } from './localized-name';

/**
 * Impure so it re-evaluates each change-detection pass; a language switch runs inside
 * the Angular zone (it triggers ngx-translate's onLangChange too), so the displayed
 * value updates without re-fetching the data.
 */
@Pipe({ name: 'localizedName', pure: false })
export class LocalizedNamePipe implements PipeTransform {
  constructor(private localeService: AppLocaleService) {}

  transform(value: any): string | undefined {
    return localizedName(value, this.localeService.current);
  }
}
